import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { LoginRoutingModule } from './login-route/login-routing.module';
import { LoginComponent } from './login.component';
import { LoginFormComponent } from './login-form/login-form.component';

@NgModule({
  imports: [
    SharedModule,
    LoginRoutingModule,
  ],
  declarations: [
    LoginComponent,
    LoginFormComponent,
  ],
  exports: [
    LoginComponent,
    LoginFormComponent,
  ]
})
export class LoginModule {}
